class MobileNavigation extends window.HTMLElement {
  constructor() {
    var _a, _b;
    super();
    this.menuToggle = this.querySelector('[data-mobile-menu-toggle="menu"]');
    this.drawer = document.querySelector("#site-nav-mobile");
    this.closeButton = (_a = this.drawer) == null ? void 0 : _a.querySelector(".close_menu");
    this.overlay = document.querySelector(".overlay_background");
    this.panels = ((_b = this.drawer) == null ? void 0 : _b.querySelectorAll("[data-menu-panel]")) ?? [];
    if (!this.menuToggle || !this.drawer || !this.closeButton || !this.overlay) return;
    this.menuToggle.addEventListener("click", () => this.open());
    this.closeButton.addEventListener("click", () => this.close());
    this.overlay.addEventListener("click", () => this.close());
    this.drawer.addEventListener("click", (event) => this.handleDrawerClick(event));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.isOpen()) this.close();
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024 && this.isOpen()) this.close(false);
    });
  }
  isOpen() {
    return this.drawer.classList.contains("is-open");
  }
  open() {
    this.showPanel("root");
    this.drawer.classList.add("is-open");
    this.drawer.setAttribute("aria-hidden", "false");
    this.menuToggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("open_menu");
    this.overlay.classList.add("opacity-100", "visible");
    this.closeButton.focus();
  }
  close(restoreFocus = true) {
    this.drawer.classList.remove("is-open");
    this.drawer.setAttribute("aria-hidden", "true");
    this.menuToggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("open_menu");
    document.documentElement.classList.remove("open_menu");
    document.body.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("overflow");
    this.overlay.classList.remove("opacity-100", "visible");
    this.drawer.querySelectorAll('[aria-expanded="true"]').forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });
    if (restoreFocus) this.menuToggle.focus();
  }
  handleDrawerClick(event) {
    const forwardButton = event.target.closest("[data-menu-target]");
    if (forwardButton) {
      forwardButton.setAttribute("aria-expanded", "true");
      this.showPanel(forwardButton.dataset.menuTarget);
      return;
    }
    const backButton = event.target.closest("[data-menu-back]");
    if (backButton) this.showPanel(backButton.dataset.menuBack);
  }
  showPanel(panelId) {
    var _a, _b;
    let activePanel = null;
    this.panels.forEach((panel) => {
      const isActive = panel.dataset.menuPanel === panelId;
      panel.classList.toggle("is-active", isActive);
      panel.setAttribute("aria-hidden", String(!isActive));
      if (isActive) activePanel = panel;
    });
    this.drawer.querySelectorAll("[data-menu-target]").forEach((button) => {
      if (button.dataset.menuTarget !== panelId) button.setAttribute("aria-expanded", "false");
    });
    (_a = activePanel == null ? void 0 : activePanel.querySelector("button, a")) == null ? void 0 : _a.focus({ preventScroll: true });
    (_b = this.drawer.querySelector(".mudify-mobile-drawer__content")) == null ? void 0 : _b.scrollTo(0, 0);
  }
}
if (!window.customElements.get("mobile-navigation")) {
  window.customElements.define("mobile-navigation", MobileNavigation);
}
